import { StyleSheet, Text, View } from "@react-pdf/renderer"
import React from "react"
import { getTextsByCategory } from "../../../../functions/FilterCards"
import { getPostitCategoryString } from "../../svg/SvgCanvas/utils/PostitUtils"
import { t } from "i18next"

interface Props {
  cards: ICard[]
  category: string | string[]
  type?: "list" | "inline" | "count"
}

const CategoryTextList: React.FC<Props> = ({ cards, category, type = "list" }) => {
  const styles = StyleSheet.create({
    title: {
      fontWeight: "bold",
      marginBottom: 4,
    },
  })

  try {

    if (type === "count" && typeof category === "string") {
      const count = cards.filter((card) => card.category === category).length
      return (
        <View style={{ marginTop: 10 }}>
          <Text style={styles.title}>
            {getPostitCategoryString(category)}: {count}
          </Text>
        </View>
      )
    }

    const texts = getTextsByCategory(cards, category as string)
    if (texts.length === 0) return null

    return (
      <View style={{ marginTop: 10 }}>
        {type === "list" ? (
          <View>
            {texts.map((text, index) => (
              <Text key={index}>• {text}</Text>
            ))}
          </View>
        ) : (
          <Text>
            <Text style={styles.title}>{getPostitCategoryString(category as string)}: </Text>
            {texts.join(", ")}
          </Text>
        )}
      </View>
    )
  } catch (error) {
    console.error("Erro ao renderizar CategoryTextList:", error)
    return (
      <View style={{ marginTop: 10 }}>
        <Text style={styles.title}>{t('feedback.error.load')}</Text>
      </View>
    )
  }
}

export default CategoryTextList
